// Plays two loud, attention-grabbing beeps using the Web Audio API.
// No external audio file required.
// Returns a controller with `stop()` for compatibility with the previous loop API.

export function playOrderAlertLoop() {
  let audioCtx;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return { stop: () => {} };
    audioCtx = new Ctx();
  } catch (e) {
    return { stop: () => {} };
  }

  const masterGain = audioCtx.createGain();
  masterGain.gain.value = 0.85;
  masterGain.connect(audioCtx.destination);

  const startTime = audioCtx.currentTime;
  const beepLength = 0.45;
  const gap = 0.18;

  // Two identical loud beeps at ~1000 Hz
  for (let i = 0; i < 2; i++) {
    const t = startTime + i * (beepLength + gap);
    const osc = audioCtx.createOscillator();
    const g = audioCtx.createGain();
    osc.type = 'square';
    osc.frequency.value = 1000;

    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(0.85, t + 0.02);
    g.gain.setValueAtTime(0.85, t + beepLength - 0.06);
    g.gain.linearRampToValueAtTime(0, t + beepLength - 0.005);

    osc.connect(g);
    g.connect(masterGain);
    osc.start(t);
    osc.stop(t + beepLength);
  }

  // Auto-close the audio context shortly after the last beep
  const totalSec = beepLength * 2 + gap + 0.3;
  const autoCloseTimer = setTimeout(() => {
    audioCtx.close().catch(() => {});
  }, totalSec * 1000);

  const stop = () => {
    clearTimeout(autoCloseTimer);
    try {
      masterGain.gain.cancelScheduledValues(audioCtx.currentTime);
      masterGain.gain.setValueAtTime(masterGain.gain.value, audioCtx.currentTime);
      masterGain.gain.linearRampToValueAtTime(0, audioCtx.currentTime + 0.05);
      setTimeout(() => audioCtx.close().catch(() => {
        /* audio context already closed — safe to ignore */
      }), 100);
    } catch (e) {
      // Best-effort cleanup. If the graceful fade failed, just force-close.
      try { audioCtx.close(); } catch (closeErr) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('AudioContext close failed:', closeErr);
        }
      }
    }
  };

  return { stop };
}
